import script from "./MenuItemWine.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemWine.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemWine.vue?vue&type=style&index=0&id=0861d090&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0861d090"]])

export default __exports__